export default __webpack_public_path__ + "static/media/mediap1050338.5de5cea5-min.26f52391.jpg";